export const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export const ROLE_OPTIONS = ["admin", "account_manager", "sales", "risk", "trader", "viewer"] as const;
